export const pageShell = 'vc-restyle-scope mx-auto max-w-[1400px] space-y-6';

export const pageTitle = 'text-2xl font-semibold tracking-tight text-foreground sm:text-3xl';

export const pageSubtitle = 'mt-1 text-sm leading-6 text-muted-foreground sm:text-base';

export const tableWrap = 'overflow-hidden rounded-lg border border-border bg-card';

export const tableScroll = 'overflow-x-auto';

export const tableBase = 'min-w-full divide-y divide-border text-sm';

export const tableHead = 'bg-muted/40';

export const tableTh = 'whitespace-nowrap px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-foreground';

export const tableTd = 'whitespace-nowrap px-4 py-3 align-middle text-foreground';

export const tableTdMuted = `${tableTd} text-muted-foreground`;

export const tableTdStrong = `${tableTd} font-medium`;

export const tableRow = 'border-b border-border last:border-0 transition-colors hover:bg-muted/40';

export const formLabel = 'mb-2 block text-sm font-medium text-foreground';

export const helpText = 'text-sm leading-6 text-muted-foreground';
